import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { useIntl } from 'react-intl'
import messages from '../../messages'
import LiquidInput from '@src/components/LiquidInput'
import { handleTabDelimitedText } from '@src/routes/Configurators/utils/TabDelimitedData'
import styles from '@src/routes/Configurators/utils/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) => ({
  rootStyle: {
    marginTop: theme.spacing(3),
  },
  textarea: {
    '& textarea': {
      overflow: 'auto',
    },
  },
}))
interface CopyEntryMTORedesignProps {
  handleChange: (event: any) => void
  text: string | undefined
}

const CopyEntryMTORedesign: React.FC<CopyEntryMTORedesignProps> = ({
  handleChange,
  text,
}) => {
  const classes = useStyles()
  const intl = useIntl()
  const GlobalCSS = styles()

  return (
    <div className={classes.rootStyle}>
      <LiquidInput
        name="copyPasteText"
        className={clsx(classes.textarea, GlobalCSS.placeHolderColorChanges)}
        filled
        placeholder={intl.formatMessage(messages.CONF_PASTE_ENTRIES_HERE_EDIT)}
        multiline
        rows={4}
        onKeyDown={(e) => {
          if (e.key === 'Tab') {
            const event = handleTabDelimitedText(e)
            handleChange(event)
          }
        }}
        value={text}
        onChange={(e) => handleChange(e)}
      />
    </div>
  )
}
export default CopyEntryMTORedesign
